/**
 * Created by mac on 7/19/18
 */

// TODO: 1 rename "sweetPack" -> "pack500", "jamPack" -> "pack1800", "tastyPack" -> "pack3800", "honeyPack" -> "pack6000", "epicPack" -> "pack25000"
// 2: simplify createByHardPrice & Kits: Product.TYPE_AUTO
// 3: unitsshop, prolongation => Product
const Product = function (data) { 
    // TODO: static properties only eg .title, .description
    // TODO: keep reference to CatalogProduct
    // TODO: connector.payments.getCatalog() returns array of localized products with current platform ids
    Object.assign(this, data);

    if (cleverapps.fallSale && cleverapps.fallSale.isProductForSale(this.itemId)) {
        Object.assign(this, FallSale.PRODUCTS[this.itemId]);
    }

    this.title = Messages.has(this.title) ? Messages.get(this.title) : this.title;
    this.description = Messages.has(this.description) ? Messages.get(this.description) : this.description;

    if (this.type === undefined) {
        this.type = Product.TYPE_NATIVE;

        if (cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_ADS) {
            if (Product.IsRealProductForAds(this.itemId) || this.context && this.context.alwaysAds) {
                this.type = Product.TYPE_ADS;

                this.prepareVideoProduct();
            }
        }
    }

    if (this.currencyImage) {
        Product.RegisterCurrencyImage(this.currency, this.currencyImage);
    }
};

Product.TYPE_NATIVE = 0;
Product.TYPE_HARD = 1;
Product.TYPE_SOFT = 2;
Product.TYPE_ADS = 3;
Product.TYPE_FREE = 4;

Product.VIDEO_HARD_COEF = 1 / 2;
Product.VIDEO_REWARD_COEF = 1 / 4;

Product.prototype.isNativeProduct = function () {
    return this.type === Product.TYPE_NATIVE;
};

Product.prototype.isSubscription = function () {
    return this.catalogProductType === "subscription";
};

Product.FormatTimePeriod = function (period, fullText) {
    if (typeof period === "object") {
        return period;
    }

    if (typeof period === "string") {
        period = cleverapps.parseInterval(period);
    }

    const secondsInHour = 60 * 60;
    const secondsInDay = secondsInHour * 24;

    let seconds = period / 1000;
    let minutes, days;

    if (fullText) {
        const codes = {
            days: {
                1: "1_day",
                2: "2_day",
                3: "3_day",
                5: "5_day",
                7: "7_day",
                9: "9_day",
                10: "10_day"
            },

            minutes: {
                15: "15_minutes",
                10: "10_minutes",
                30: "30_minutes",
                45: "45_minutes",
                60: "OneHour",
                120: "TwoHours",
                180: "ThreeHours",
                360: "6_hours",
                720: "12_hours"
            }
        };

        minutes = Math.round(seconds / 60);
        days = Math.floor(seconds / secondsInDay);

        return {
            title: `TimePeriod.${codes.days[days] || codes.minutes[minutes]}`,
            time: period
        };
    }

    days = Math.floor(seconds / secondsInDay);
    seconds %= secondsInDay;

    const hours = Math.floor(seconds / secondsInHour);
    seconds %= secondsInHour;

    minutes = Math.round(seconds / 60);

    const toReplace = {
        day: days,
        hr: hours,
        min: minutes
    };

    let code = "minutesString";
    if (days > 0 && hours > 0) {
        code = "dayTimeString";
    } else if (days > 0) {
        code = "daysString";
    } else if (hours > 0 && minutes > 0) {
        code = "hoursMinutesString";
    } else if (hours > 0) {
        code = "hoursString";
    }

    return {
        title: code,
        time: period,
        toReplace
    };
};

Product.prototype.getIcon = function () {
    return cleverapps.skins.getSlot(this.icon)
        || bundles.tile_shop.jsons[this.icon] || bundles.tile_shop.frames[this.icon]
        || this.icon;
};

Product.prototype.prepareVideoProduct = function () {
    const coef = Product.VIDEO_REWARD_COEF;

    if (this.reward) {
        if (this.reward.hard) {
            this.reward.hard = Math.ceil(this.reward.hard * Product.VIDEO_HARD_COEF / 10) * 10;
        }

        ["soft", "energy", "wands"].forEach(function (key) {
            if (this.reward[key]) {
                this.reward[key] = Math.ceil(this.reward[key] * coef / 10) * 10;
            }
        }, this);

        if (this.reward.boosters) {
            Object.keys(this.reward.boosters).forEach(function (key) {
                this.reward.boosters[key] = Math.ceil(this.reward.boosters[key] * coef);
            }, this);
        }
    }

    this.price = Math.ceil(Math.ceil(this.priceUSD * coef * 2) * 5 / 2);

    if (Product.DOUBLE_ADS_PRICE_PREFIXES.some((prefix) => this.itemId.startsWith(prefix))) {
        this.price *= 2;
    }
};

Product.prototype.getCurrentPrice = function () {
    if (this.type === Product.TYPE_ADS) {
        return `##${this.getVideoProgress()}/${this.price}`;
    }

    return Product.ReplacePriceCurrencyIcon(this.textPrice);
};

Product.prototype.getAdsLimit = function () {
    return this.adsLimit ? this.adsLimit() : AdsLimits.TYPES.PRODUCT;
};

Product.prototype.getVideoProgressKey = function () {
    const event = this.getBuyEventFromContext();
    let key = DataLoader.TYPES.PRODUCT_VIDEO_PROGRESS + this.itemId + (event ? `_${event}` : "");

    if (this.context && this.context.type === "pass_ticket") {
        key += `_${Restorable.LocationMission(this, this.context)}`;
    }

    return key;
};

Product.prototype.getVideoProgress = function () {
    return cleverapps.dataLoader.load(this.getVideoProgressKey()) || 0;
};

Product.prototype.saveVideoProgress = function (progress) {
    if (progress) {
        cleverapps.dataLoader.save(this.getVideoProgressKey(), progress);
    } else {
        cleverapps.dataLoader.remove(this.getVideoProgressKey());
    }
};

Product.prototype.isAvailable = function () {
    if (this.type === Product.TYPE_ADS) {
        return [AdsLimits.STATE_READY, AdsLimits.STATE_NOT_LOADED].includes(cleverapps.adsLimits.state(this.getAdsLimit()));
    }

    return connector.payments.isConnected();
};

Product.prototype.getUsdPrice = function () {
    return this.priceUSD;
};

Product.prototype.showBoughtMessage = function (reward) {
    if (!this.image) {
        return;
    }

    // TODO: remove custom params to Product constructor options
    const message = this.boughtMessage || "Product.YouBought";
    const toReplace = { ...this.boughtMessageParams };
    toReplace.moves = this.moves;

    if (toReplace.title) {
        toReplace.title = Messages.get(toReplace.title);
    }

    if (reward && (reward.hard || reward.soft)) {
        toReplace.coins = reward.hard || reward.soft;
    }

    const imageUrl = connector.platform.getExternalUrl(this.image);
    cc.loader.load(imageUrl, (status) => {
        let image = undefined;
        if (!status) {
            image = new cc.Sprite(imageUrl);
        }
        cleverapps.notification.create(Messages.get(message, toReplace), {
            image
        });
    });
};

Product.prototype.logBuyItem = function () {
    const controller = cleverapps.focusManager.listWindows()
        .map((win) => ComponentUtils.findComponentByName(win, "ShopWindowController"))
        .find(Boolean);

    const properties = {
        store_type: controller && controller.getTitle(),
        item_name: this.constructor === Product ? this.title : undefined,
        item_price: this.price,
        cost_type: this.currency
    };

    const rewardId = Object.keys(this.reward || {})[0];
    if (rewardId) {
        properties.item_id = rewardId;
        properties.item_num = this.reward[rewardId];
    }

    if (this.itemId.startsWith("buyEnergy")) {
        properties.item_id = "energy";
        properties.item_num = this.reward;
    }

    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.BUY_ITEM, properties);
};

Product.prototype.getSpentEventFromContext = function (options = {}) {
    if (!this.context) {
        return;
    }

    const compact = options.compact;

    const context = this.context;
    const offer = context.offer && Offers[context.offer];
    const expedition = context.expedition || offer && offer.location || cleverapps.meta.selectedLocationId();

    switch (context.type) {
        case "mission_offer":
        case "chain_sale":
        case "supplies_sale":
        case "oneplusone_offer":
        case "promotion_sale": {
            const name = context.name || offer && offer.name;
            return name && (compact ? "o" : cleverapps.EVENTS.SPENT.OFFER) + name;
        }
        case "special_offer": return cleverapps.EVENTS.SPENT.GENIE_ENERGY;
        case "third_element": return cleverapps.EVENTS.SPENT.THIRD_ELEMENT;
        case "offers": return cleverapps.EVENTS.SPENT.PIXEL_OFFER;
        case "fogs":
            return compact ? cleverapps.EVENTS.SPENT.PAY_ISLAND : [expedition, context.fogId].filter(Boolean).join("_");
        case "worker": return cleverapps.EVENTS.SPENT.WORKER;
        case "last_chance": return cleverapps.EVENTS.SPENT.LAST_CHANCE;
        case "pass_ticket": return cleverapps.EVENTS.SPENT.BATTLE_PASS;
        case "season_pass_vip":
        case "season_pass_super":
        case "season_pass_super_upgrade":
            return `${compact ? "o" : cleverapps.EVENTS.SPENT.OFFER}SeasonPass`;
        case "season_pass_last_chance":
            return `${compact ? "o" : cleverapps.EVENTS.SPENT.OFFER}SeasonPassLastChance`;
    }
};

Product.prototype.getBuyEventFromContext = function () {
    const context = this.context || {};
    const offer = context.offer && Offers[context.offer];
    const expedition = context.expedition || offer && offer.location || cleverapps.meta.selectedLocationId();

    if (this.itemId === "expeditionPack") {
        return expedition;
    }

    switch (context.type) {
        case "mission_offer":
        case "chain_sale":
        case "supplies_sale":
        case "oneplusone_offer":
        case "promotion_sale":
            return context.name || offer && offer.name;
        case "fogs":
            return [expedition, context.fogId].filter(Boolean).join("_");
        default:
            return context.type;
    }
};

Product.prototype.buy = function (f, options) {
    if (this.type === Product.TYPE_ADS) {
        cleverapps.paymentsLogic.purchaseVideoProduct(this, f, options);
    } else {
        cleverapps.paymentsLogic.purchase(this, f, options);
    }
};

Product.CreateById = function (id, context) {
    // TODO: move context to connector.payments.restoreProduct native method?
    // TODO: static products, do not modify, no need .clone
    const catalogProduct = connector.payments.getProduct(id);

    if (Products[id] && catalogProduct) {
        catalogProduct.catalogProductType = catalogProduct.type;
        delete catalogProduct.type;

        return new Product(Object.assign(
            catalogProduct,
            cleverapps.clone(Products[id], true),
            { context }
        ));
    }

    // TODO: homogeneous Products & Virtual products, convert one to vise versa (eg Kits, VideoProducts)
    if (VirtualProducts[id]) {
        return new VirtualProduct({
            itemId: id,
            ...cleverapps.clone(VirtualProducts[id], true),
            context
        });
    }
};

Product.CreateByHardPrice = function (hardPrice, context, productIds) {
    productIds = (productIds || ["kit1", "kit3", "kit10", "kit50"]).filter(Product.IsPurchasable);

    const products = productIds.map((id) => Product.CreateById(id, context)).filter((product) => product && product.getUsdPrice());

    let closestProduct = undefined;
    let closestDiff = undefined;
    const usdPrice = hardPrice * Product.HARD_TO_USD;
    for (let i = 0; i < products.length; ++i) {
        const product = products[i];
        const diff = Math.abs(1 - usdPrice / product.getUsdPrice());

        if (diff <= Product.USD_EXCHANGE_THRESHOLD && (!closestProduct || diff < closestDiff)) {
            closestProduct = product;
            closestDiff = diff;
        }
    }

    return closestProduct || new VirtualProduct({
        itemId: `hard${hardPrice}`,
        currency: "hard",
        price: hardPrice,
        type: Product.TYPE_HARD,
        context
    });
};

Product.CalcHardPrice = function (id) {
    const product = Product.CreateById(id);
    const usd = product && product.getUsdPrice();
    return usd ? usd / Product.HARD_TO_USD : 0;
};

Product.RegisterCurrencyImage = function (currency, image) {
    const replacer = `\${${currency}}`;

    if (Product.CURRENCY_ICONS[replacer]) {
        return;
    }

    Product.CURRENCY_ICONS[replacer] = {
        currency,
        url: image,
        size: 50
    };

    if (typeof image === "string") {
        cc.loader.load(image);
    }
};

Product.ReplacePriceCurrencyIcon = function (price) {
    Object.keys(Product.CURRENCY_ICONS).forEach((replacer) => {
        const currency = Product.CURRENCY_ICONS[replacer].currency;

        price = price.replace(` ${currency}`, replacer);
    });

    return price;
};

Product.IsVideoProductsEnabled = function () {
    return cleverapps.abExperiments.isInitialized() && cleverapps.abExperiments.getGroup(ABExperiments.Tests.videoProducts) === "A";
};

Product.IsRealProductForAds = function (itemId) {
    return Product.REAL_PRODUCTS_FOR_ADS.includes(itemId)
        || Product.IsVideoProductsEnabled() && Product.REAL_PRODUCT_PREFIXES_FOR_ADS.some((prefix) => itemId.startsWith(prefix));
};

Product.HasPaymentMethod = function () {
    return cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_REGULAR
        || cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_ADS && Product.IsVideoProductsEnabled();
};

Product.IsPurchasable = function (itemId) {
    switch (cleverapps.flags.monetization) {
        case cleverapps.Flags.MONETIZATION_REGULAR: return true;
        case cleverapps.Flags.MONETIZATION_ADS: return Product.IsVideoProductsEnabled() && Product.IsRealProductForAds(itemId);
        default: return false;
    }
};

Product.REAL_PRODUCTS_FOR_ADS = ["gold500", "gold1800", "gold3800", "gold6000", "gold25000", "sweetPack", "jamPack", "tastyPack", "honeyPack", "epicPack"];
Product.REAL_PRODUCT_PREFIXES_FOR_ADS = ["hard", "kit", "island", "piggybank"];
Product.DOUBLE_ADS_PRICE_PREFIXES = ["kit", "island"];

Product.USD_EXCHANGE_THRESHOLD = 0.21;

Product.HARD_TO_USD = 0.0011;
if (["merge", "merge2"].includes(cleverapps.config.type)) {
    Product.HARD_TO_USD = 0.01;
}

Product.CURRENCY_ICONS = {
    "${OK}": {
        currency: "OK",
        url: bundles.buttons_inlined_icons.frames.ok_icon_png
    },
    "${KG}": {
        currency: "KG",
        url: bundles.buttons_inlined_icons.frames.kred_icon_png
    },
    "${BEANS}": {
        currency: "BEANS",
        url: bundles.buttons_inlined_icons.frames.beans_icon_png
    },
    "${GEMS}": {
        currency: "GEMS",
        url: bundles.buttons_inlined_icons.frames.gems_icon_png
    },
    "${RDT}": {
        currency: "RDT",
        url: bundles.buttons_inlined_icons.frames.reddit_gold_icon_png
    }
};